const COVER_ROOT = `${process.env.PUBLIC_URL || ""}/profile-covers`;

const buildTheme = ({
  id,
  label,
  description,
  image,
  baseColor,
  overlay,
  border,
  line,
  banner,
  horizon,
  zodiacGlow,
  interestIds = [],
  creditLabel,
  creditUrl,
}) => ({
  id,
  label,
  description,
  image,
  interestIds,
  creditLabel,
  creditUrl,
  previewStyle: {
    backgroundImage: `${overlay}, url("${image}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  style: {
    "--profile-cover-base": baseColor,
    "--profile-cover-image": `url("${image}")`,
    "--profile-cover-overlay": overlay,
    "--profile-cover-border": border,
    "--profile-cover-line": line,
    "--profile-cover-banner": banner,
    "--profile-cover-horizon": horizon,
    "--profile-cover-zodiac-glow": zodiacGlow,
  },
});

export const DEFAULT_PROFILE_COVER_THEME_ID = "roadtrip-sunset";

export const PROFILE_COVER_THEMES = [
  buildTheme({
    id: "dance-latine",
    label: "Danse latine",
    description: "Salsa, bachata, kizomba, tango et sorties danse.",
    image: `${COVER_ROOT}/dance-latine.jpg`,
    interestIds: ["danse", "salsa", "bachata", "kizomba", "tango"],
    creditLabel: "Adrian Gonzalo / Pexels",
    creditUrl: "https://www.pexels.com/photo/elegant-couple-dancing-on-street-27010304/",
    baseColor: "#1d0e17",
    overlay:
      "linear-gradient(180deg, rgba(12,6,10,.28), rgba(12,6,10,.76) 84%)",
    border: "rgba(255, 140, 118, 0.24)",
    line: "rgba(255, 152, 125, 0.34)",
    banner:
      "linear-gradient(180deg, rgba(122, 42, 62, 0.84), rgba(71, 24, 39, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(255, 190, 156, 0.28), transparent 20%), linear-gradient(180deg, transparent, rgba(12,6,10,.16)), linear-gradient(90deg, rgba(72,24,38,.82), rgba(198,94,89,.18) 38%, rgba(72,24,38,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(251,146,60,.3), rgba(244,114,182,.22) 40%, rgba(253,186,116,.12) 66%, transparent 78%)",
  }),
  buildTheme({
    id: "gaming-neon",
    label: "Gaming",
    description: "Gaming, tech, setup et univers neon.",
    image: `${COVER_ROOT}/gaming-neon.jpg`,
    interestIds: ["gaming"],
    creditLabel: "Atahan Demir / Pexels",
    creditUrl:
      "https://www.pexels.com/photo/stylish-gaming-setup-with-neon-lighting-33050961/",
    baseColor: "#0b1226",
    overlay:
      "linear-gradient(180deg, rgba(5,8,18,.26), rgba(5,8,18,.78) 86%)",
    border: "rgba(134, 126, 255, 0.22)",
    line: "rgba(184, 140, 255, 0.32)",
    banner:
      "linear-gradient(180deg, rgba(56, 45, 121, 0.84), rgba(25, 20, 69, 0.92))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(236, 153, 255, 0.24), transparent 20%), linear-gradient(180deg, transparent, rgba(5,8,18,.16)), linear-gradient(90deg, rgba(24,20,69,.84), rgba(160,69,246,.18) 36%, rgba(18,22,60,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(192,132,252,.32), rgba(59,130,246,.22) 42%, rgba(244,114,182,.12) 66%, transparent 78%)",
  }),
  buildTheme({
    id: "yoga-zen",
    label: "Yoga",
    description: "Yoga, bien-etre, meditation et self-care.",
    image: `${COVER_ROOT}/yoga-zen.jpg`,
    interestIds: ["yoga"],
    creditLabel: "Yan Krukau / Pexels",
    creditUrl: "https://www.pexels.com/photo/a-woman-in-activewear-meditating-8436942/",
    baseColor: "#121822",
    overlay:
      "linear-gradient(180deg, rgba(10,14,20,.2), rgba(10,14,20,.72) 84%)",
    border: "rgba(174, 197, 226, 0.24)",
    line: "rgba(160, 196, 230, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(64, 86, 118, 0.82), rgba(33, 49, 72, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(204, 226, 248, 0.22), transparent 20%), linear-gradient(180deg, transparent, rgba(10,14,20,.14)), linear-gradient(90deg, rgba(35,49,72,.82), rgba(118,148,178,.16) 38%, rgba(35,49,72,.88) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(191,219,254,.28), rgba(96,165,250,.16) 40%, rgba(255,255,255,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "food-gourmet",
    label: "Food",
    description: "Cuisine, restos, brunch et moments gourmands.",
    image: `${COVER_ROOT}/food-gourmet.jpg`,
    interestIds: ["food", "cuisine"],
    creditLabel: "Rachel Claire / Pexels",
    creditUrl: "https://www.pexels.com/photo/food-served-on-the-table-in-a-restaurant-8113058/",
    baseColor: "#1a1110",
    overlay:
      "linear-gradient(180deg, rgba(12,8,8,.22), rgba(12,8,8,.72) 84%)",
    border: "rgba(255, 177, 126, 0.22)",
    line: "rgba(255, 173, 117, 0.3)",
    banner:
      "linear-gradient(180deg, rgba(114, 70, 38, 0.84), rgba(68, 38, 20, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(255, 214, 153, 0.24), transparent 20%), linear-gradient(180deg, transparent, rgba(12,8,8,.16)), linear-gradient(90deg, rgba(67,38,19,.82), rgba(226,162,83,.16) 38%, rgba(67,38,19,.88) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(251,191,36,.3), rgba(251,146,60,.2) 40%, rgba(255,237,213,.1) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "roadtrip-sunset",
    label: "Roadtrip",
    description: "Voyage, escapades et routes au coucher du soleil.",
    image: `${COVER_ROOT}/roadtrip-sunset.jpg`,
    interestIds: ["roadtrip", "voyage", "afterwork"],
    creditLabel: "Tolga Aslanturk / Pexels",
    creditUrl: "https://www.pexels.com/photo/sunset-view-of-road-from-moving-vehicle-14146975/",
    baseColor: "#15171f",
    overlay:
      "linear-gradient(180deg, rgba(8,10,14,.18), rgba(8,10,14,.74) 84%)",
    border: "rgba(255, 183, 134, 0.24)",
    line: "rgba(255, 170, 122, 0.32)",
    banner:
      "linear-gradient(180deg, rgba(94, 82, 112, 0.82), rgba(44, 40, 67, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(255, 212, 160, 0.26), transparent 20%), linear-gradient(180deg, transparent, rgba(8,10,14,.16)), linear-gradient(90deg, rgba(44,40,67,.82), rgba(179,116,120,.16) 38%, rgba(44,40,67,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(253,186,116,.3), rgba(244,114,182,.18) 40%, rgba(191,219,254,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "surf-ocean",
    label: "Surf",
    description: "Surf, ocean, plage et energie libre.",
    image: `${COVER_ROOT}/surf-ocean.jpg`,
    interestIds: ["surf", "nature", "voyage"],
    creditLabel: "Nicole Avagliano / Pexels",
    creditUrl: "https://www.pexels.com/photo/ocean-waves-with-surfer-at-sunset-beach-16354146/",
    baseColor: "#081927",
    overlay:
      "linear-gradient(180deg, rgba(4,11,18,.18), rgba(4,11,18,.74) 84%)",
    border: "rgba(112, 225, 255, 0.24)",
    line: "rgba(99, 224, 255, 0.32)",
    banner:
      "linear-gradient(180deg, rgba(18, 91, 117, 0.82), rgba(8, 48, 70, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(167, 237, 255, 0.26), transparent 20%), linear-gradient(180deg, transparent, rgba(4,11,18,.16)), linear-gradient(90deg, rgba(8,48,70,.82), rgba(34,126,171,.16) 38%, rgba(8,48,70,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(34,211,238,.32), rgba(59,130,246,.2) 42%, rgba(207,250,254,.1) 66%, transparent 78%)",
  }),
  buildTheme({
    id: "randonnee-sunset",
    label: "Randonnee",
    description: "Nature, randonnee, outdoor et grands paysages.",
    image: `${COVER_ROOT}/randonnee-sunset.jpg`,
    interestIds: ["randonnee", "nature", "camping"],
    creditLabel: "Marek Piwnicki / Pexels",
    creditUrl: "https://www.pexels.com/photo/hiking-trail-on-the-mountain-top-8387381/",
    baseColor: "#10161b",
    overlay:
      "linear-gradient(180deg, rgba(7,10,12,.2), rgba(7,10,12,.76) 84%)",
    border: "rgba(177, 205, 171, 0.22)",
    line: "rgba(178, 216, 170, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(70, 92, 78, 0.82), rgba(32, 44, 38, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(218, 233, 184, 0.22), transparent 20%), linear-gradient(180deg, transparent, rgba(7,10,12,.16)), linear-gradient(90deg, rgba(32,44,38,.82), rgba(136,174,125,.16) 38%, rgba(32,44,38,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(163,230,53,.24), rgba(250,204,21,.16) 40%, rgba(255,255,255,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "concert-live",
    label: "Concert",
    description: "Lives, festivals, scenes et ambiances scène.",
    image: `${COVER_ROOT}/concert-live.jpg`,
    interestIds: ["musique", "concerts", "festivals"],
    creditLabel: "Noland Live / Pexels",
    creditUrl: "https://www.pexels.com/photo/crowd-at-the-concert-at-night-26447525/",
    baseColor: "#090b14",
    overlay:
      "linear-gradient(180deg, rgba(4,5,10,.26), rgba(4,5,10,.78) 84%)",
    border: "rgba(253, 186, 44, 0.22)",
    line: "rgba(253, 200, 60, 0.3)",
    banner:
      "linear-gradient(180deg, rgba(90, 48, 8, 0.84), rgba(44, 20, 4, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(254, 215, 170, 0.26), transparent 20%), linear-gradient(180deg, transparent, rgba(4,5,10,.16)), linear-gradient(90deg, rgba(44,20,4,.82), rgba(217,119,6,.18) 38%, rgba(44,20,4,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(251,191,36,.32), rgba(245,158,11,.2) 40%, rgba(255,251,235,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "running-urban",
    label: "Running",
    description: "Course, sport outdoor et depassement de soi.",
    image: `${COVER_ROOT}/running-urban.jpg`,
    interestIds: ["running", "sport", "fitness"],
    creditLabel: "Alexander Tisko / Pexels",
    creditUrl: "https://www.pexels.com/photo/dynamic-runner-in-urban-corridor-black-and-white-35541691/",
    baseColor: "#111111",
    overlay:
      "linear-gradient(180deg, rgba(6,6,6,.22), rgba(6,6,6,.78) 84%)",
    border: "rgba(229, 229, 229, 0.2)",
    line: "rgba(229, 229, 229, 0.26)",
    banner:
      "linear-gradient(180deg, rgba(60, 60, 60, 0.84), rgba(20, 20, 20, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(255, 255, 255, 0.18), transparent 20%), linear-gradient(180deg, transparent, rgba(6,6,6,.16)), linear-gradient(90deg, rgba(20,20,20,.82), rgba(160,160,160,.12) 38%, rgba(20,20,20,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(255,255,255,.22), rgba(200,200,200,.14) 40%, rgba(255,255,255,.06) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "ski-montagne",
    label: "Ski",
    description: "Ski, snowboard, stations et grands domaines.",
    image: `${COVER_ROOT}/ski-montagne.jpg`,
    interestIds: ["ski", "snowboard", "sport", "montagne"],
    creditLabel: "Sabina Kallari / Pexels",
    creditUrl: "https://www.pexels.com/photo/people-skiing-and-snowboarding-at-night-under-the-lift-20513867/",
    baseColor: "#0e151e",
    overlay:
      "linear-gradient(180deg, rgba(6,9,14,.22), rgba(6,9,14,.76) 84%)",
    border: "rgba(186, 230, 253, 0.24)",
    line: "rgba(186, 230, 253, 0.3)",
    banner:
      "linear-gradient(180deg, rgba(20, 52, 84, 0.84), rgba(8, 24, 44, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(224, 242, 254, 0.24), transparent 20%), linear-gradient(180deg, transparent, rgba(6,9,14,.16)), linear-gradient(90deg, rgba(8,24,44,.82), rgba(56,130,200,.14) 38%, rgba(8,24,44,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(186,230,253,.28), rgba(125,211,252,.18) 40%, rgba(240,249,255,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "bar-cocktail",
    label: "Afterwork",
    description: "Bars, cocktails, afterwork et ambiances tamisées.",
    image: `${COVER_ROOT}/bar-cocktail.jpg`,
    interestIds: ["afterwork", "bars", "cocktails"],
    creditLabel: "MART PRODUCTION / Pexels",
    creditUrl: "https://www.pexels.com/photo/photo-of-a-woman-sitting-near-the-bartender-7270015/",
    baseColor: "#0e0c1a",
    overlay:
      "linear-gradient(180deg, rgba(8,6,14,.28), rgba(8,6,14,.78) 84%)",
    border: "rgba(167, 139, 250, 0.22)",
    line: "rgba(167, 139, 250, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(60, 30, 100, 0.84), rgba(28, 12, 52, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(233, 213, 255, 0.22), transparent 20%), linear-gradient(180deg, transparent, rgba(8,6,14,.16)), linear-gradient(90deg, rgba(28,12,52,.82), rgba(124,58,237,.16) 38%, rgba(28,12,52,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(167,139,250,.3), rgba(139,92,246,.2) 40%, rgba(237,233,254,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "ville-nuit",
    label: "Nuits de ville",
    description: "Sorties nocturnes, bars, expos et ambiances urbaines.",
    image: `${COVER_ROOT}/ville-nuit.jpg`,
    interestIds: ["nightlife", "sorties", "afterwork", "urban"],
    creditLabel: "Kevin Galerken / Pexels",
    creditUrl: "https://www.pexels.com/photo/the-city-of-new-york-on-a-rainy-night-7258774/",
    baseColor: "#0d0c16",
    overlay:
      "linear-gradient(180deg, rgba(6,5,12,.26), rgba(6,5,12,.78) 84%)",
    border: "rgba(250, 204, 21, 0.22)",
    line: "rgba(253, 212, 40, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(80, 56, 8, 0.84), rgba(36, 24, 4, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(253, 230, 138, 0.24), transparent 20%), linear-gradient(180deg, transparent, rgba(6,5,12,.16)), linear-gradient(90deg, rgba(36,24,4,.82), rgba(202,138,4,.18) 38%, rgba(36,24,4,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(250,204,21,.3), rgba(245,158,11,.2) 40%, rgba(255,251,235,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "montagne-alpes",
    label: "Montagne",
    description: "Alpinisme, trekking et grands paysages montagnards.",
    image: `${COVER_ROOT}/montagne-alpes.jpg`,
    interestIds: ["montagne", "alpinisme", "trekking", "nature"],
    creditLabel: "Albin Ejupi / Pexels",
    creditUrl: "https://www.pexels.com/photo/dramatic-mountain-peaks-in-gosau-austria-33745844/",
    baseColor: "#0f1820",
    overlay:
      "linear-gradient(180deg, rgba(6,10,14,.24), rgba(6,10,14,.78) 84%)",
    border: "rgba(148, 163, 184, 0.22)",
    line: "rgba(148, 163, 184, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(34, 52, 72, 0.84), rgba(14, 26, 40, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(226, 232, 240, 0.22), transparent 20%), linear-gradient(180deg, transparent, rgba(6,10,14,.16)), linear-gradient(90deg, rgba(14,26,40,.82), rgba(71,85,105,.16) 38%, rgba(14,26,40,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(186,230,253,.24), rgba(147,197,253,.16) 40%, rgba(241,245,249,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "jazz-piano",
    label: "Jazz",
    description: "Jazz, piano-bar, concerts intimistes et ambiances tamisees.",
    image: `${COVER_ROOT}/jazz-piano.jpg`,
    interestIds: ["jazz", "musique", "concerts", "culture"],
    creditLabel: "Anthony / Pexels",
    creditUrl: "https://www.pexels.com/photo/pianist-performing-in-dimly-lit-lounge-34977994/",
    baseColor: "#1a0e08",
    overlay:
      "linear-gradient(180deg, rgba(14,6,4,.26), rgba(14,6,4,.78) 84%)",
    border: "rgba(217, 119, 6, 0.22)",
    line: "rgba(217, 119, 6, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(92, 36, 8, 0.84), rgba(44, 16, 4, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(254, 215, 170, 0.24), transparent 20%), linear-gradient(180deg, transparent, rgba(14,6,4,.16)), linear-gradient(90deg, rgba(44,16,4,.82), rgba(180,83,9,.18) 38%, rgba(44,16,4,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(217,119,6,.3), rgba(251,146,60,.2) 40%, rgba(255,237,213,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "moto-road",
    label: "Moto",
    description: "Moto, roadtrip, liberte et grands horizons.",
    image: `${COVER_ROOT}/moto-road.jpg`,
    interestIds: ["moto", "roadtrip", "voyage", "sport"],
    creditLabel: "Koushik Bala / Pexels",
    creditUrl: "https://www.pexels.com/photo/silhouette-of-a-man-riding-a-motorcycle-at-sunset-15038722/",
    baseColor: "#1a1008",
    overlay:
      "linear-gradient(180deg, rgba(14,8,4,.22), rgba(14,8,4,.76) 84%)",
    border: "rgba(249, 115, 22, 0.22)",
    line: "rgba(249, 115, 22, 0.3)",
    banner:
      "linear-gradient(180deg, rgba(124, 45, 18, 0.84), rgba(62, 20, 8, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(254, 215, 170, 0.26), transparent 20%), linear-gradient(180deg, transparent, rgba(14,8,4,.16)), linear-gradient(90deg, rgba(62,20,8,.82), rgba(234,88,12,.18) 38%, rgba(62,20,8,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(249,115,22,.32), rgba(245,158,11,.2) 40%, rgba(255,237,213,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "natation-pool",
    label: "Natation",
    description: "Natation, piscine, plongee et sports nautiques.",
    image: `${COVER_ROOT}/natation-pool.jpg`,
    interestIds: ["natation", "plongee", "sport", "piscine"],
    creditLabel: "Kindel Media / Pexels",
    creditUrl: "https://www.pexels.com/photo/underwater-view-of-a-swimming-pool-8688163/",
    baseColor: "#061624",
    overlay:
      "linear-gradient(180deg, rgba(4,10,16,.22), rgba(4,10,16,.76) 84%)",
    border: "rgba(34, 211, 238, 0.24)",
    line: "rgba(34, 211, 238, 0.3)",
    banner:
      "linear-gradient(180deg, rgba(8, 78, 104, 0.84), rgba(4, 38, 56, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(103, 232, 249, 0.24), transparent 20%), linear-gradient(180deg, transparent, rgba(4,10,16,.16)), linear-gradient(90deg, rgba(4,38,56,.82), rgba(6,182,212,.18) 38%, rgba(4,38,56,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(34,211,238,.32), rgba(6,182,212,.22) 40%, rgba(207,250,254,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "yoga-nature",
    label: "Yoga outdoor",
    description: "Yoga en plein air, meditation et connexion a la nature.",
    image: `${COVER_ROOT}/yoga-nature.jpg`,
    interestIds: ["yoga", "meditation", "nature", "bienetre"],
    creditLabel: "Guilherme Xac / Pexels",
    creditUrl: "https://www.pexels.com/photo/person-practice-yoga-on-mountain-at-sunset-5466261/",
    baseColor: "#1a1508",
    overlay:
      "linear-gradient(180deg, rgba(14,10,4,.22), rgba(14,10,4,.74) 84%)",
    border: "rgba(250, 204, 21, 0.22)",
    line: "rgba(250, 204, 21, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(100, 68, 8, 0.82), rgba(50, 32, 4, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(253, 230, 138, 0.24), transparent 20%), linear-gradient(180deg, transparent, rgba(14,10,4,.14)), linear-gradient(90deg, rgba(50,32,4,.82), rgba(202,138,4,.16) 38%, rgba(50,32,4,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(250,204,21,.28), rgba(251,191,36,.18) 40%, rgba(255,249,195,.08) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "foret-sombre",
    label: "Foret",
    description: "Nature sauvage, forets profondes et plein air mystique.",
    image: `${COVER_ROOT}/foret-sombre.jpg`,
    interestIds: ["nature", "foret", "randonnee", "camping"],
    creditLabel: "Felix / Pexels",
    creditUrl: "https://www.pexels.com/photo/moody-forest-scene-with-moss-covered-tree-29300254/",
    baseColor: "#080e08",
    overlay:
      "linear-gradient(180deg, rgba(4,8,4,.24), rgba(4,8,4,.78) 84%)",
    border: "rgba(74, 222, 128, 0.18)",
    line: "rgba(74, 222, 128, 0.22)",
    banner:
      "linear-gradient(180deg, rgba(14, 42, 14, 0.84), rgba(6, 20, 6, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(187, 247, 208, 0.18), transparent 20%), linear-gradient(180deg, transparent, rgba(4,8,4,.14)), linear-gradient(90deg, rgba(6,20,6,.82), rgba(22,163,74,.14) 38%, rgba(6,20,6,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(74,222,128,.24), rgba(34,197,94,.16) 40%, rgba(240,253,244,.06) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "voiture-vintage",
    label: "Vintage",
    description: "Voitures de collection, retro et passion mecanique.",
    image: `${COVER_ROOT}/voiture-vintage.jpg`,
    interestIds: ["voiture", "vintage", "mecanique", "retro"],
    creditLabel: "Mathias Reding / Pexels",
    creditUrl: "https://www.pexels.com/photo/vintage-car-in-dark-garage-setting-29198168/",
    baseColor: "#0e0e0e",
    overlay:
      "linear-gradient(180deg, rgba(6,6,6,.22), rgba(6,6,6,.78) 84%)",
    border: "rgba(161, 161, 170, 0.22)",
    line: "rgba(161, 161, 170, 0.26)",
    banner:
      "linear-gradient(180deg, rgba(50, 50, 50, 0.84), rgba(18, 18, 18, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(228, 228, 231, 0.18), transparent 20%), linear-gradient(180deg, transparent, rgba(6,6,6,.14)), linear-gradient(90deg, rgba(18,18,18,.82), rgba(113,113,122,.14) 38%, rgba(18,18,18,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(228,228,231,.22), rgba(161,161,170,.14) 40%, rgba(250,250,250,.06) 64%, transparent 78%)",
  }),
  buildTheme({
    id: "boxe-gym",
    label: "Gym",
    description: "Fitness, musculation, arts martiaux et depassement.",
    image: `${COVER_ROOT}/boxe-gym.jpg`,
    interestIds: ["fitness", "musculation", "boxe", "sport"],
    creditLabel: "KoolShooters / Pexels",
    creditUrl: "https://www.pexels.com/photo/a-boxing-gym-9944633/",
    baseColor: "#111212",
    overlay:
      "linear-gradient(180deg, rgba(6,6,6,.24), rgba(6,6,6,.78) 84%)",
    border: "rgba(239, 68, 68, 0.22)",
    line: "rgba(239, 68, 68, 0.28)",
    banner:
      "linear-gradient(180deg, rgba(100, 22, 22, 0.84), rgba(50, 10, 10, 0.9))",
    horizon:
      "radial-gradient(circle at 50% 100%, rgba(254, 202, 202, 0.22), transparent 20%), linear-gradient(180deg, transparent, rgba(6,6,6,.16)), linear-gradient(90deg, rgba(50,10,10,.82), rgba(185,28,28,.16) 38%, rgba(50,10,10,.9) 72%)",
    zodiacGlow:
      "radial-gradient(circle, rgba(239,68,68,.3), rgba(220,38,38,.2) 40%, rgba(254,226,226,.08) 64%, transparent 78%)",
  }),
];

export function getProfileCoverTheme(themeId) {
  return (
    PROFILE_COVER_THEMES.find((theme) => theme.id === themeId) ||
    PROFILE_COVER_THEMES.find(
      (theme) => theme.id === DEFAULT_PROFILE_COVER_THEME_ID
    ) ||
    PROFILE_COVER_THEMES[0]
  );
}
